import React from 'react';
import cx from 'classnames';

import CardLayout from '@magoosh/layouts/card';
import { DangerAlert } from '@magoosh/lib/alerts';
import { FontAwesomeIcon } from '@magoosh/lib/icons';

import AboutMagooshContent from './about_magoosh_content';
import TemplateOptionAndEmailForm from './template_option_and_email_form';
import WhatYoullGetContent from './what_youll_get_content';

import MagooshLogo from '@magoosh/assets/magoosh-logo-purple.png';
import PurpleConfettiBackground from './assets/purple_confetti_bg.png';
import style from './style.module.scss';

interface Props {
  branding: {
    examName: string;
  };
  error?: string;
  planSlug: string;
  referrerName: string;
  templateOptions: {
    estimatedLength: string;
    name: string;
    sectionId?: number;
    templateId: number;
  }[];
}

const FreeMockTest: React.FC<Props> = (props) => {
  return (
    <>
      <div className={cx(style.container, 'd-flex flex-column-reverse flex-md-row')}>
        <div className={cx(style.infoSection, 'd-flex flex-column')}>
          <WhatYoullGetContent examName={props.branding.examName} />
          <AboutMagooshContent examName={props.branding.examName} />
        </div>

        <div className={cx(style.formSection, 'flex-1')}>
          <img alt="Magoosh" className={style.logo} src={MagooshLogo} />

          <h1 className="text-body u-margin-T-l">
            <strong>Free {props.branding.examName} Practice Test and Score Report</strong>
          </h1>

          {props.error && <DangerAlert className="u-margin-V-s">{props.error}</DangerAlert>}

          <p>This practice test is designed to simulate the experience you will have taking the {props.branding.examName} on test day.</p>
          <p>You'll see questions just like the real exam, get an accurate score, and  report of your strengths and weaknesses to guide your studies.</p>

          <div className="u-margin-V-m">
            <TemplateOptionAndEmailForm
              planSlug={props.planSlug}
              templateOptions={props.templateOptions}
            />
          </div>

          <small className="text-gray-light">
            <FontAwesomeIcon icon="lock" /> Magoosh will keep your information private and secure.
            {props.referrerName && <>{' '}We will share your email with our partner {props.referrerName}.</>}
          </small>
        </div>
      </div>
    </>
  );
};

export default FreeMockTest;
